<div class="maintenance" style="background-image: url('assets/img/png/under_maintenace.png');" *ngIf="_mainService.maintenanceContent">
    <div class="logo">
        <a href="javascript:void(0)">
            <img src="assets/img/svg/logo_white.svg" alt="">
        </a>
    </div>
    <div class="maintenance__info">
        <div class="img">
           <img src="assets/img/png/maintenace_icon.png" alt="">
        </div>
<div class="inner--content">
    <h3>{{_mainService.maintenanceContent.text1}}</h3>
    <p class="mb-3">{{_mainService.maintenanceContent.text2}} </p>
    <p class="mb-0">{{_mainService.maintenanceContent.text3}}</p>
</div>

    </div>
</div>